import React from 'react';
import PropTypes from 'prop-types';
import {AppBar, Divider, Drawer, Hidden, IconButton, List, Toolbar, ListItemButton, ListItemIcon, ListItemText, Typography, Box, FormControlLabel, Switch, Tooltip, } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import { makeStyles, useTheme } from '@mui/styles';
import {
  ArrowBack,
  Menu as MenuIcon,
  Apps,
  AdminPanelSettings,
  Groups,
  Flag,
  Campaign,
  NoteAdd,
  MonitorHeart,
  VpnKey,
} from '@mui/icons-material'
import AssignContact from '../AssignContact';
import EditContact from '../EditContact';
import SettingManager from '../SettingManager';
import SalesManagement from '../SalesManagement';
import ContactLeadsReport from '../ContactLeadsReport';
import { Link } from 'react-router-dom';
import SetupChatUsers from '../SetupChatUsers';
import SetupChatUser2 from '../SetupChatUsers/SetupChatUser2';
import SalesResponseTimeReport from '../SalesResponseTimeReport';
import AppProfile from '../AppProfile';
import CheckpointSettings from '../CheckpointSettings';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import { useHistory } from 'react-router-dom';
import LoginMonitoring from '../LoginMonitoring/LoginMonitoring';
import HsmFuSettings from '../HsmFuSettings';
import HsmMonitoring from '../HsmMonitoring/HsmMonitoring';
import HsmSettings from '../HsmSettings';

const drawerWidth = 260;

const MENU_ITEMS = [
  { id: "APP_PROFILE", title: "App profile", icon: <Apps />, show: () => Global.isSuperUser() },
  { id: "PRIVILEGES", title: "Privileges", icon: <AdminPanelSettings />, show: () => !Global.isSuperUser() },
  { id: "SALES", title: "Sales", icon: <Groups /> },
  { id: "CHECKPOINT_SETTINGS", title: "Checkpoint", icon: <Flag /> },
  { id: "HSM_FU_SETTINGS", title: "HSM Follow Up", icon: <Campaign /> },
  { id: "HSM_INPUT_SETTINGS", title: "Input HSM", icon: <NoteAdd /> },
  { id: "HSM_MONITORING", title: "HSM Monitoring", icon: <MonitorHeart /> },
  { id: "LOGIN_MONITORING", title: "Login Monitoring", icon: <VpnKey /> },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
}));

function SettingsResponsive(props) {
  const { window: settingWindow } = props;
  // const theme = useTheme();
  // const classes = useStyles();

  let lotusConsoleEnabled = localStorage.getItem("lotus_console_enabled");

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [consoleEnabled, setConsoleEnabled] = React.useState(lotusConsoleEnabled !== null && lotusConsoleEnabled !== undefined ? (lotusConsoleEnabled === "false" ? false : true) : Api.isConsoleEnabled);
  const [currentPage, setCurrentPage] = React.useState({title: "App Profile", id: "APP_PROFILE"});

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleConsoleEnabled = () => {
    localStorage.setItem("lotus_console_enabled", !consoleEnabled);
    setConsoleEnabled(!consoleEnabled);
    console.log("HANDLECONSOLE");
    window.location.reload("/");
  }

  const menuItemSx = (selected) => ({
    borderRadius: '8px',
    mb: 0.5,
    mx: 1,
    '&.Mui-selected': {
      bgcolor: 'primary.main',
      color: '#fff',
      '& .MuiListItemIcon-root': { color: '#fff' },
      '&.Mui-selected:hover': { bgcolor: 'primary.dark' },
    },
  });

  const drawer = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 1.5, bgcolor: 'primary.main', color: '#fff' }}>
        <Box sx={{ bgcolor: 'rgba(255,255,255,0.18)', borderRadius: '8px', p: 0.75, display: 'flex' }}>
          <Apps fontSize="small" />
        </Box>
        <Typography variant="subtitle1" fontWeight={700} noWrap>Lotus Settings</Typography>
      </Toolbar>
      <Divider />

      <List sx={{ flexGrow: 1, overflowY: 'auto', py: 1 }}>
        {MENU_ITEMS.filter((item) => (item.show ? item.show() : true)).map((item) => {
          const selected = currentPage.id === item.id;
          return (
            <ListItemButton
              key={item.id}
              selected={selected}
              onClick={() => setCurrentPage({ title: item.title, id: item.id })}
              sx={menuItemSx(selected)}
            >
              <ListItemIcon sx={{ minWidth: 40, color: selected ? '#fff' : 'text.secondary' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} primaryTypographyProps={{ fontSize: '0.9rem', fontWeight: 600 }} />
            </ListItemButton>
          );
        })}
      </List>

      {Global.isSuperUser() && (
        <>
          <Divider />
          <Box sx={{ p: 1 }}>
            <Typography variant="overline" color="text.secondary" sx={{ pl: 1.5 }}>Admin Tools</Typography>
            {/* <ListItemButton
              selected={currentPage.id === "LOGIN_MONITORING"}
              onClick={() => setCurrentPage({ title: "Login Monitoring", id: "LOGIN_MONITORING" })}
              sx={menuItemSx(currentPage.id === "LOGIN_MONITORING")}
            >
              <ListItemIcon sx={{ minWidth: 40, color: currentPage.id === "LOGIN_MONITORING" ? '#fff' : 'text.secondary' }}>
                <VpnKey />
              </ListItemIcon>
              <ListItemText primary="Login Monitoring" primaryTypographyProps={{ fontSize: '0.9rem', fontWeight: 600 }} />
            </ListItemButton> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 0.5,
                mx: 1,
                px: 1.5,
                py: 1,
                borderRadius: '8px',
                bgcolor: '#f5f5f5',
              }}
            >
              <FormControlLabel
                sx={{ m: 0, flexGrow: 1 }}
                control={<Switch size="small" onChange={handleConsoleEnabled} checked={consoleEnabled} />}
                label={<Typography variant="body2" fontWeight={600}>Console enabled</Typography>}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );

  const container = settingWindow !== undefined ? () => settingWindow().document.body : undefined;

  return (
    // <div className={classes.root}>
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {/* <AppBar position="fixed" className={classes.appBar}> */}
      <AppBar position="fixed"
        elevation={1}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}>
        <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          <Tooltip title="Close Settings">
            <IconButton
              component={Link}
              to="/"
              size="small"
              sx={{
                color: '#fff',
                bgcolor: 'rgba(255,255,255,0.14)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.24)' },
              }}
            >
              <ArrowBack fontSize="small" />
            </IconButton>
          </Tooltip>
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)', mx: 1.5, my: 1.5 }} />
          <Typography variant="h6" fontWeight={700} noWrap sx={{ flexGrow: 1 }}>
            {currentPage.title}
          </Typography>
        </Toolbar>
      </AppBar>
      {/* <nav className={classes.drawer} aria-label="mailbox folders"> */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
            {drawer}
          </Drawer>
        </Hidden>
      </Box>
      {/* <main className={classes.content}> */}
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        {/* <div className={classes.toolbar} /> */}
        <Toolbar />
        {/* <div className="container"> */}
            {
                currentPage.id === "CONTACT_BARU" ? <AssignContact /> : <></>
            }

            {
                currentPage.id === "EDIT_CONTACT" ? <EditContact /> : <></>
            }

            {
                currentPage.id === "PRIVILEGES" ? <SettingManager /> : <></>
            }

            {
                currentPage.id === "SALES" ? <SalesManagement /> : <></>
            }

            {
                currentPage.id === "LEADS_REPORT" ? <ContactLeadsReport /> : <></>
            }

            {
                currentPage.id === "SETUP_CHAT_USERS" ? <SetupChatUser2 /> : <></>
            }

            {
                currentPage.id === "SALES_RESPONSE_TIME_REPORT" ? <SalesResponseTimeReport /> : <></>
            }

            {
                currentPage.id === "APP_PROFILE" ? <AppProfile /> : <></>
            }

            {
                currentPage.id === "CHECKPOINT_SETTINGS" ? <CheckpointSettings /> : <></>
            }

            {
                currentPage.id === "LOGIN_MONITORING" ? <LoginMonitoring /> : <></>
            }

            {
                currentPage.id === "HSM_FU_SETTINGS" ? <HsmFuSettings /> : <></>
            }

            {
                currentPage.id === "HSM_MONITORING" ? <HsmMonitoring /> : <></>
            }

            {
                currentPage.id === "HSM_INPUT_SETTINGS" ? <HsmSettings /> : <></>
            }
        {/* </div> */}
      </Box>
    </Box>
  );
}

export default SettingsResponsive;
